<template>
    <div class="consumerPrivacyPolicy">
        <iframe class="policyFrame" scrolling:="no" frameborder="0" src="https://consumer-portal-public-bucket.s3.us-east-1.amazonaws.com/Privacy+Policy+-+5-2025.pdf#toolbar=0&navpanes=0&scrollbar=0&zoom=FitH"></iframe>
</div>
<FooterComp></FooterComp>
  </template>

  <script>
  import FooterComp from '@/components/Footer_Comp.vue';

  export default {
  name: "TermsOfUse",
  components: {
    FooterComp
  }}
</script>

<style>
.policyFrame{
    width: 100%;
    height: 100vh;
    margin-top: 140px;
    border: none;
    overflow: hidden;
}
.consumerPrivacyPolicy{
    justify-self: center;
    align-self: center;
    width: 80%;
}

</style>